import { useCallback } from 'react';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { videoSDKAdapterAtom } from '../core/atoms';
import { DataChannelMessage } from '../core/message/types';

export function useSendMessage() {
  const getAdapter = useAtomCallbackMemoized((get) => get(videoSDKAdapterAtom), []);

  return useCallback(
    async (message: DataChannelMessage): Promise<boolean> => {
      const result = await getAdapter().sendMessage(message);

      return result;
    },
    [getAdapter],
  );
}
